"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Клик на кнопку "Перейти к результату" на экране навыка для перехода в отчет по прохождению теста */
const verificationKeySkillToDetailResultButtonClick = ({ verificationTestName, isDetail, isBrand, isPaidClick, nameBrand, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("verification_key_skill_to_detail_result", { verificationTestName, isDetail, isBrand, isPaidClick, nameBrand, ...analyticsParams });
exports.default = verificationKeySkillToDetailResultButtonClick;
